import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ProjectState {
  selectedProjectId: number | null;
  setSelectedProjectId: (projectId: number) => void;
  clearSelectedProjectId: () => void;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set) => ({
      selectedProjectId: null,
      setSelectedProjectId: (projectId) => set({ selectedProjectId: projectId }),
      clearSelectedProjectId: () => set({ selectedProjectId: null }),
    }),
    {
      name: 'smalt_selected_project',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ selectedProjectId: state.selectedProjectId }),
    }
  )
);

